export default __webpack_public_path__ + "static/media/certificado-semana-iot.ea29a421.svg";